import { Link } from "react-router-dom";
import ContactLinks from "./contactLinks";

const AboutUs = () => {

    return (
        <>


            {/* <!--hero part start here!--> */}

            <section className='hearo-wrap hero-inner'>
                <div className='container'>

                    {/* <!--=========Bread Crum!=====================--> */}
                    <div className='bread-crum'>

                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                                <li className="breadcrumb-item active" aria-current="page">About</li>
                            </ol>
                        </nav>

                    </div>
                    {/* <!--=========Bread Crum!=====================--> */}
                </div>

                <div className='container hero-bx padding-top-bot'>
                    {/* <!--exchange part!--> */}



                    <div className='row justify-content-center'>
                        <div className='col-md-7'>

                            <h1 className='hero-title top-title'>How Kittrow Investments s.r.o. Investments Works & <br />Why You Can Trust It</h1>

                        </div>


                    </div>
                </div>
                {/* <!--exchange part!--> */}






            </section>



            {/* <!--===================About page!======================--> */}

            <section className='container sec-pad-t'>

                <div className='row align-items-center'>
                    {/* <!--============Step box wrapper!==========--> */}

                    <div className='col-xl-5 col-md-6'>

                        <h2 className='sec-title'>Our Commitment to Compliance</h2>
                        <p>At Kittrow Investments s.r.o., we believe trust starts with transparency. That’s why we follow global compliance standards, including AML and KYC regulations. We combine best practices from traditional banking with cutting-edge blockchain technology to provide a secure
                            and legal environment for exchanging crypto to fiat and back.</p>

                        <p>We only work with trusted partners, verified users, and cryptocurrencies that meet our internal security and compliance benchmarks.</p>
                    </div>
                    <div className='col-xl-7 col-md-6'>
                        <div className='img-full'>
                            <img src='assets/images/placeholder-photo.png' alt='' />
                        </div>
                    </div>


                </div>
                {/* <!--============Step box wrapper!==========--> */}


                <div className='row sec-pad-t align-items-center'>
                    {/* <!--============Step box wrapper!==========--> */}


                    <div className='col-xl-7 col-md-6'>
                        <div className='img-full'>
                            <img src='assets/images/placeholder-photo.png' alt='' />
                        </div>
                    </div>
                    <div className='col-xl-5 col-md-6'>

                        <h2 className='sec-title'>About Kittrow Investments s.r.o.: <br />Mission & Vision</h2>
                        <p>Kittrow Investments s.r.o. is building the future of finance — simple, borderless,
                            and inclusive. We want to help over one billion people gain control over their money through crypto. By simplifying access to crypto and offering fast, legal conversions to fiat, we are creating tools for true financial freedom.</p>

                        <p>Our long-term vision is to bridge traditional banking and decentralized finance (DeFi), making crypto usable for everyone — from beginners to developers.</p>
                    </div>

                </div>
                {/* <!--============Step box wrapper!==========--> */}






            </section>



            {/* <!--========================Kittrow Investments s.r.o. in Number!===============--> */}

            <section className='container kit-numb numb-abt sec-pad-t'>
                <h2 className='sec-title'>Kittrow Investments s.r.o. in numbers</h2>
                <div className='row'>
                    <div className='col-md-3'>
                        <div className='kit-wrap'>
                            <div className='icon'><img src='assets/images/m-trans.png' /></div>
                            <p>Transfers per month</p>
                            <h3>1200+</h3>
                        </div>
                    </div>

                    <div className='col-md-3'>
                        <div className='kit-wrap'>
                            <div className='icon'><img src='assets/images/time.png' /></div>
                            <p>Avg. Withdrawal</p>
                            <h3>5 mins</h3>
                        </div>
                    </div>

                    <div className='col-md-3'>
                        <div className='kit-wrap'>
                            <div className='icon'><img src='assets/images/exchange1.png' /></div>
                            <p>Supported currency</p>
                            <h3>50+</h3>
                        </div>
                    </div>

                    <div className='col-md-3'>
                        <div className='kit-wrap'>
                            <div className='icon'><img src='assets/images/bank.png' /></div>
                            <p>Bank integrations</p>
                            <h3>10+</h3>
                        </div>
                    </div>

                    <div className='col-md-3'>
                        <div className='kit-wrap'>
                            <div className='icon'><img src='assets/images/partner.png' /></div>
                            <p>Global Partnerships</p>
                            <h3>50+</h3>
                        </div>
                    </div>

                    <div className='col-md-3'>
                        <div className='kit-wrap'>
                            <div className='icon'><img src='assets/images/country.png' /></div>
                            <p>Countries serverd</p>
                            <h3>35+</h3>
                        </div>
                    </div>

                    <div className='col-md-3'>
                        <div className='kit-wrap'>
                            <div className='icon'><img src='assets/images/customer.png' /></div>
                            <p>Customer Retention</p>
                            <h3>90%+</h3>
                        </div>
                    </div>

                    <div className='col-md-3'>
                        <div className='kit-wrap'>
                            <div className='icon'><img src='assets/images/talk.png' /></div>
                            <p>Customer support</p>
                            <h3>24/7</h3>
                        </div>
                    </div>
                </div>
            </section>


            {/* <!--==================Content Box!=================--> */}

            <section className='container sec-pad-t'>

                <div className='row align-items-center'>
                    {/* <!--============Step box wrapper!==========--> */}

                    <div className='col-xl-5 col-md-6'>

                        <h2 className='sec-title'>Why Choose Kittrow Investments s.r.o.?</h2>
                        <p>We don't just offer crypto exchange — we deliver a complete ecosystem. Kittrow Investments s.r.o. is focused on simplicity, speed, and legal clarity. You don’t need to be a crypto expert to use our platform — everything is designed with the average user in mind.</p>

                        <p>Our mission is to eliminate friction and help you move value globally — without the stress, confusion, or hidden fees.</p>
                    </div>
                    <div className='col-xl-7 col-md-6'>
                        <div className='img-full'>
                            <img src='assets/images/placeholder-photo.png' alt='' />
                        </div>
                    </div>


                </div>
                {/* <!--============Step box wrapper!==========--> */}


                <div className='row sec-pad-t align-items-center'>
                    {/* <!--============Step box wrapper!==========--> */}


                    <div className='col-xl-7 col-md-6'>
                        <div className='img-full'>
                            <img src='assets/images/placeholder-photo.png' alt='' />
                        </div>
                    </div>
                    <div className='col-xl-5 col-md-6'>

                        <h2 className='sec-title'>The Road Ahead</h2>
                        <p>Kittrow Investments s.r.o. continues to grow — not just in users, but in values.
                            We’re actively partnering with regulators, improving user experience, and developing next-generation features for exchanging and using crypto in everyday life.</p>

                        <p>We’re just getting started. Join us on this journey to change how the world uses money.</p>
                    </div>

                </div>
                {/* <!--============Step box wrapper!==========--> */}






            </section>




            {/* <!--===========================Button information part!================--> */}

            <section className='container sec-pad-t'>
                <h2 className='sec-title text-center'>Contact us</h2>
                <ContactLinks />
            </section>

            <div className='sec-pad-t'></div>
            {/* <!--=============Spacer!===========--> */}


        </>
    );
}

export default AboutUs;